import React from 'react'

import moment from 'moment'

import styles from '../styles'

const BuildRestrictions = (props) => {
  const { restrictionsData } = props
  const classes = styles()

  try {
    return (
      <div className={classes.expansibleContent}>
        {restrictionsData?.consists ? (
          restrictionsData?.restrictions?.map((restriction) => {
            return (
              <React.Fragment key={`restriction:${restriction.uuid}`}>
                <p>
                  <strong style={{ textTransform: 'capitalize' }}>
                    {restriction?.list_name}
                  </strong>
                </p>

                <div className={classes.restrictions}>
                  <span>
                    <b>Nome: </b>
                    {restriction?.subject_name}
                  </span>

                  <span>
                    <b>Pseudônimo(s): </b>
                    {restriction?.pseudonyms ? restriction?.pseudonyms : 'N/A'}
                  </span>

                  <span>
                    <b>Data da Entrada: </b>
                    {moment(restriction?.entry_date).format('DD/MM/YYYY')}
                  </span>

                  <span>
                    <b>Data da Saída: </b>
                    {restriction?.exit_date
                      ? moment(restriction?.exit_date).format('DD/MM/YYYY')
                      : 'permanece na lista restritiva'}
                  </span>
                </div>
              </React.Fragment>
            )
          })
        ) : (
          <div className={classes.expansibleContent}>
            <span>Nenhum registro encontrado.</span>
          </div>
        )}
      </div>
    )
  } catch (err) {
    reportError(err, 'Restrictions List', restrictionsData)
    return (
      <div className={classes.errorCaptured}>
        <span>Ocorreu um erro ao tratar os dados de Listas Restritivas</span>
      </div>
    )
  }
}

export default BuildRestrictions
